export default __webpack_public_path__ + "static/media/close-login.c8f3ba34.svg";